(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const closeOverlays = () => {
    $$('.ux-nav-drawer.is-open,.ux-search-modal.is-open').forEach((el) => el.classList.remove('is-open'));
    document.documentElement.classList.remove('ux-locked');
  };

  const formatBundleMoney = (cents, module) => {
    const currency = module?.dataset.currency || window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents || 0) / 100); }
    catch (_) { return `$${(Number(cents || 0) / 100).toFixed(2)}`; }
  };

  const updateBundleTotal = (module, cents, priceText) => {
    const output = $('[data-ux-bundle-atc-text]', module);
    const button = $('[data-add-to-cart]', module);
    if (!output || button?.disabled) return;
    const label = button.dataset.atcLabel || 'Add to Cart';
    output.textContent = `${label} — ${priceText || formatBundleMoney(cents, module)}`;
  };

  const selectBundleChoice = (choice) => {
    if (!choice || choice.getAttribute('aria-disabled') === 'true') return;
    const module = choice.closest('[data-ux-bundle-purchase]');
    if (!module) return;
    const quantity = Math.max(1, Number(choice.dataset.quantity || 1));
    const mode = choice.dataset.mode || 'standard';
    const sellingPlan = choice.dataset.sellingPlan || '';
    $$('[data-ux-bundle-choice]', module).forEach((el) => {
      const selected = el === choice;
      el.classList.toggle('is-active', selected);
      el.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    const quantityInput = $('[data-ux-bundle-quantity]', module);
    const quantityOutput = $('[data-ux-bundle-qty-value]', module);
    const sellingPlanInput = $('[data-ux-bundle-selling-plan]', module);
    const propertyInput = $('[data-ux-bundle-property]', module);
    if (quantityInput) quantityInput.value = quantity;
    if (quantityOutput) quantityOutput.textContent = quantity;
    if (sellingPlanInput) {
      sellingPlanInput.value = mode === 'subscription' ? sellingPlan : '';
      sellingPlanInput.disabled = mode !== 'subscription' || !sellingPlan;
    }
    if (propertyInput) propertyInput.value = choice.dataset.property || '';
    module.dataset.activeMode = mode;
    module.dataset.activeUnitCents = Math.round(Number(choice.dataset.totalCents || 0) / quantity);
    updateBundleTotal(module, choice.dataset.totalCents, choice.dataset.priceText);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ux-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.uxOpen);
      if (target) {
        event.preventDefault();
        closeOverlays();
        target.classList.add('is-open');
        document.documentElement.classList.add('ux-locked');
        setTimeout(() => $('input', target)?.focus(), 100);
      }
    }
    if (event.target.closest('[data-ux-close]')) closeOverlays();

    const thumb = event.target.closest('[data-ux-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-ux-gallery]');
      const main = $('[data-ux-main-image]', gallery);
      if (main) {
        main.removeAttribute('srcset');
        main.src = thumb.dataset.uxSrc;
        main.alt = thumb.dataset.uxAlt || main.alt;
        $$('[data-ux-thumb]', gallery).forEach((el) => el.classList.toggle('is-active', el === thumb));
      }
    }

    const bundleChoice = event.target.closest('[data-ux-bundle-choice]');
    if (bundleChoice) {
      event.preventDefault();
      selectBundleChoice(bundleChoice);
      return;
    }

    const bundleQuantity = event.target.closest('[data-ux-bundle-qty]');
    if (bundleQuantity) {
      event.preventDefault();
      const module = bundleQuantity.closest('[data-ux-bundle-purchase]');
      const quantityInput = $('[data-ux-bundle-quantity]', module);
      const current = Math.max(1, Number(quantityInput?.value || 1));
      const next = Math.min(99, Math.max(1, current + (bundleQuantity.dataset.uxBundleQty === 'plus' ? 1 : -1)));
      if (next === current) return;
      const active = $('[data-ux-bundle-choice].is-active', module);
      const mode = active?.dataset.mode || module.dataset.activeMode || 'standard';
      if (mode === 'standard') {
        const matching = $(`[data-ux-bundle-choice][data-mode="standard"][data-quantity="${next}"]`, module);
        if (matching) {
          selectBundleChoice(matching);
          return;
        }
        $$('[data-ux-bundle-choice]', module).forEach((el) => { el.classList.remove('is-active'); el.setAttribute('aria-checked', 'false'); });
      }
      const quantityOutput = $('[data-ux-bundle-qty-value]', module);
      const propertyInput = $('[data-ux-bundle-property]', module);
      if (quantityInput) quantityInput.value = next;
      if (quantityOutput) quantityOutput.textContent = next;
      if (propertyInput) propertyInput.value = mode === 'subscription' ? `${active?.dataset.property || 'Subscription'} × ${next}` : `Buy ${next}`;
      const unitCents = Number(active?.dataset.totalCents || module.dataset.activeUnitCents || module.dataset.baseCents || 0) / Math.max(1, Number(active?.dataset.quantity || 1));
      module.dataset.activeMode = mode;
      module.dataset.activeUnitCents = Math.round(unitCents);
      updateBundleTotal(module, Math.round(unitCents * next));
      return;
    }

    const option = event.target.closest('[data-ux-supply]');
    if (option) {
      const module = option.closest('[data-ux-purchase]');
      $$('[data-ux-supply]', module).forEach((el) => el.classList.toggle('is-active', el === option));
      $$('input[name="quantity"]', module).forEach((input) => { input.value = option.dataset.quantity || 1; });
      $$('[data-ux-buy-price]', module).forEach((el) => { el.textContent = option.dataset.price || ''; });
    }

    const copy = event.target.closest('[data-ux-copy]');
    if (copy) {
      const showCopied = () => {
        const label = $('[data-ux-copy-label]', copy);
        if (label) { const old = label.textContent; label.textContent = 'Copied'; setTimeout(() => { label.textContent = old; }, 1800); }
      };
      const fallbackCopy = () => {
        const field = document.createElement('textarea');
        field.value = copy.dataset.uxCopy || '';
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
        document.body.appendChild(field);
        field.select();
        try { document.execCommand('copy'); } catch (_) { /* Visual feedback still confirms the attempted copy. */ }
        field.remove();
        showCopied();
      };
      if (window.navigator?.clipboard?.writeText) {
        window.navigator.clipboard.writeText(copy.dataset.uxCopy || '').then(showCopied).catch(fallbackCopy);
      } else {
        fallbackCopy();
      }
    }

    const more = event.target.closest('[data-ux-load-more]');
    if (more) {
      const target = document.getElementById(more.dataset.uxLoadMore);
      $$('[hidden]', target).forEach((el) => el.removeAttribute('hidden'));
      more.hidden = true;
    }

    const buyNow = event.target.closest('[data-ux-buy-now]');
    if (buyNow) {
      event.preventDefault();
      const form = buyNow.closest('[data-ux-main-form]')?.querySelector('form');
      if (form) {
        buyNow.disabled = true;
        fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
          .then((response) => { if (!response.ok) throw new Error('Unable to add'); window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout'); })
          .catch(() => { buyNow.disabled = false; form.requestSubmit(); });
      }
    }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeOverlays(); });

  const setHeader = () => $('.ux-header')?.classList.toggle('is-scrolled', window.scrollY > 24);
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });

  $$('[data-ux-compare]').forEach((wrap) => {
    const range = $('input[type="range"]', wrap);
    const after = $('.ux-before-after__after', wrap);
    const line = $('.ux-before-after__line', wrap);
    if (!range || !after || !line) return;
    const update = () => { const value = `${range.value}%`; after.style.clipPath = `inset(0 ${100 - range.value}% 0 0)`; line.style.left = value; };
    range.addEventListener('input', update); update();
  });

  const sticky = $('.ux-sticky-atc');
  const mainForm = $('[data-ux-main-form]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(mainForm);
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ux-contact-form]');
    if (!form) return;
    event.preventDefault();
    const status = $('[data-ux-form-status]', form);
    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Request failed');
      form.reset();
      if (status) { status.textContent = 'Thanks — our team will reply within one business day.'; status.classList.add('ux-form-status--success'); }
    } catch (_) {
      form.submit();
    }
  });
})();
